<template>
    <a-modal v-model="visible" title="编辑" on-ok="handleSubmit">
        <template slot="footer">
            <a-button key="submit" type="primary" :loading="loading" @click=" handleSubmit">
            确定
            </a-button>
            <a-button key="back"   @click="handleCancel">
            取消
            </a-button>
        </template>

        <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }" @submit="handleSubmit">
            <a-form-item label="账号名">
                <a-input allowClear
                  v-decorator="['alias', { rules: [{ required: true, message: '请输入账号名!' },
                    { pattern: /^[A-z0-9\u4e00-\u9fa5]{1,20}$/, message: '仅支持20位以内中英文数字字符'}
                   ],initialValue:text.alias  }]"
                />
            </a-form-item>
            <a-form-item label="手机号码">
              <a-input placeholder="请输入" allowClear v-decorator="['account', { rules: [{ required: true, message: '请输入手机号!' },{ pattern: /^1[3456789]\d{9}$/, message: '请输入正确手机号码'}], initialValue:text.account }]"/>
            </a-form-item>
        </a-form>

    </a-modal>
</template>
<script>
export default {
  props:{
    mode:{
      type:String,
      default:'1'
    }
  },
  data() {
    return {
      formItemLayout:'',
      loading: false,
      visible: false,
      formLayout: 'horizontal',
      text:{},
      form: this.$form.createForm(this, { name: 'coordinated' }),
      ownId:0,
      account:''
    };
  },
  created(){
    this.ownId = localStorage.getItem("ownId")||0;
    this.account = localStorage.getItem("account")||'';

  },
  methods: {
    logout(){
      this.$http.post('signout').then(res=>{
        this.$router.push({name:'login'})
        // console.log('登出成功');
      })
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          let params = {...values}
          params.id = this.text.id;
          let url = '';
          if (this.mode=='1') {
            url = '/manager/modifyRecord'
          } else if(this.mode=='2'){
             url = '/supplier/modifyRecord'
          }else if(this.mode=='3'){
             url = '/distributor/modifyRecord'
          }
          this.$http.post(url,params).then(res=>{
            if (res.result) {
              this.$message.success('修改成功')
              let id = localStorage.getItem("id")||'';
              if(params.id == this.ownId && this.account != params.account){
                this.logout();
              }else if (params.id == id) {
                this.$store.commit('handleUserName',params.alias);
                this.$forceUpdate();
              }
              this.handleCancel();
              this.$emit("getdata");
            }else{
              this.$message.warning(res.message)
            }
          })
        }
      });
    },
    showModal(text) {
      this.text = text;
      this.visible = true;
    },
    handleCancel(e) {
      this.visible = false;
      this.form.resetFields();
    },
  },
};
</script>
